import { isValidPublicId } from '@/lib/public-id';

/**
 * R3 shared URL builder for every /org/:orgId/* navigate, Link, and test goto.
 * Mirrors workspaceUrl() (see ./workspace-url.ts) for the Organization view:
 * single source of truth for the org-scoped URL shape, throws loudly on a
 * malformed publicId instead of silently rendering /org/undefined/*.
 */
export function orgUrl(orgId: string, sub?: string): string {
  if (!isValidPublicId(orgId, 'org')) {
    throw new TypeError(`orgUrl: invalid org publicId "${orgId}"`);
  }
  if (!sub) return `/org/${orgId}`;
  return `/org/${orgId}/${sub.replace(/^\/+/, '')}`;
}
